import React from "react";
import "./ComponentLoaderStyle.css";

const ComponentLoader = () => {
  return (
    <div className="center-body">
      <div className="dotsLoader" role="status" aria-label="Loading">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default ComponentLoader;
